/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Brouillon
 * 1 = Envoye
 * 2 = EnTraitement
 * 3 = Cloture
 * 4 = Annule
 */
export enum StatutRapportIncident {
  Brouillon = 0,
  Envoye = 1,
  EnTraitement = 2,
  Cloture = 3,
  Annule = 4
}
